module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noind",
    attrs: {
      "id": "dedication"
    }
  }, [_vm._v("To my buddy Jacqueline Woodson")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("extraordinary writer,")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("friend,")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("role model.")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("For reminding me that")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("good intentions")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("are not")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("good enough.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27294b63","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/4-dedication.vue
// module id = 63
// module chunks = 0